<template>
  <div class="d-flex justify-end my-4 mr-6">
    <v-btn
      color="primary"
      class="mb-2 rounded-pill elevation-0"
      @click="$emit('addItem')"
      :disabled="loading"
    >
      New User
    </v-btn>

    <v-btn
      icon
      color="warning"
      class="mb-2 ml-2"
      @click="$emit('getData')"
      :loading="loading"
      :disabled="loading"
    >
      <v-icon>mdi-refresh</v-icon>
    </v-btn>

    <v-menu offset-y rounded="lg" transition="slide-y-transition" bottom left>
      <template v-slot:activator="{ on, attrs }">
        <v-btn color="warning" class="mb-2" icon dark v-bind="attrs" v-on="on">
          <v-icon light size="20">mdi-dots-vertical</v-icon>
        </v-btn>
      </template>
      <v-list dense>
        <v-list-item link @click="$emit('exportItem')">
          <v-list-item-icon>
            <v-icon>mdi-file-excel</v-icon>
          </v-list-item-icon>
          <v-list-item-title>Export to excel</v-list-item-title>
        </v-list-item>
      </v-list>
    </v-menu>
  </div>
</template>

<script>
export default {
  props: {
    loading: Boolean,
  }
};
</script>
